import React, { FC } from 'react'

import { BarProps } from '@Components/CMS/Bars/types'
import { RTEContent } from '@Components/RTEContent'
import GenericBar from '@Domains/Header/Features/Bars/Generic'
import { getRTEFieldValue, useDynamicVariables } from '@Globals/CMS/FieldHelpers'

export const DefaultBar: FC<BarProps> = ({ bar, className, id, order, placement }) => {
  const dynamicVariables = useDynamicVariables()
  const text = getRTEFieldValue(bar.fields || [], 'text')
  const textLeft = getRTEFieldValue(bar.fields || [], 'textLeft')
  const mobileRTEField = getRTEFieldValue(bar.fields || [], 'textMobile')
  const textRight = getRTEFieldValue(bar.fields || [], 'textRight')

  return (
    <GenericBar
      key={bar.id}
      backgroundColor={bar.backgroundColor}
      className={className}
      contentLeft={textLeft && <RTEContent data={textLeft} dynamicVariables={dynamicVariables} />}
      contentMiddle={text && <RTEContent data={text} dynamicVariables={dynamicVariables} />}
      contentMobile={mobileRTEField && <RTEContent data={mobileRTEField} dynamicVariables={dynamicVariables} />}
      contentRight={textRight && <RTEContent data={textRight} dynamicVariables={dynamicVariables} />}
      id={id}
      order={order}
      placement={placement}
      textColor={bar.textColor}
    />
  )
}

export default DefaultBar
